import React from 'react'
import { moneyColumn, numVal } from '../../../modules/Utils'
import { moneyInline } from '../../../modules/Utils'

function MoneyCell(props) {
  const { value, currency = '' } = props
  if (value === undefined) return <span />
  else return <span style={props.style}>{moneyInline(numVal({ value }, 'value'), currency)}</span>
}
export default MoneyCell
